// extracted by mini-css-extract-plugin
export default {"title":"gaa-z","warning":"haa-z","sizeOptionsLegendText":"iaa-z"};